type Message<T extends string, V extends object | void = void> = {
  action: T;
} & (V extends object ? { payload: V } : { payload?: never });

export type IncomingMessage<
  T extends string,
  V extends object | void = void,
> = Message<T, V>;
export type OutgoingMessage<
  T extends string,
  V extends object | void = void,
> = Message<T, V>;

/**
 * For local testing use http://embedded.localhost:3000/
 */
export function isEmbedded(): boolean {
  if (typeof window === 'undefined') return false;

  return (
    window.location.hostname === 'embedded-maps.stackdx.com' ||
    window.location.hostname === 'staging-embedded-maps.stackdx.com' ||
    window.location.hostname === 'embedded.localhost'
  );
}

export const embeddedLog = {
  debug: (message: string, ...args: any[]) => {
    console.log('%c[embedded]', 'color: #009688', message, ...args);
  },
  error: (message: string, ...args: any[]) =>
    console.log('%c[embedded error]', 'color: #F44336', message, ...args),
};
